import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import useProjectFacade from "../../../facade/project.Facade";
import { useAppSelector } from "../../../store/hooks/StoreHooks";
import Tabs from "../../common/Tabs";
import TextInput from "../../common/textinput";
import SelectCreate from "../../common/select-create";
import Modal from "../../common/Modal";
import { myProjects } from "../../../store/model/MyProjects";
import useDocumentFacade from "../../../facade/documents/documents.facade";
import useCreateProjectFacade from "../../../facade/createProject.Facade";
import Success from "../../../assets/icons/Success";
import MyArchivedProjects from "./myprojects";
import OtherArchivedProjects from "./other-projects";
import ChipsDropdown, { OptionsProps } from "../../common/chips-dropdown";

const documentInitialState = {
  SortDto: { Field: "UpdatedOn", Order: "DESC" },
  Filters: [],
  GlobalFilter: "",
  PageNumber: 1,
  PageSize: 10,
};

const ArchivedProjects = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const [currentParams, setCurrentParams] = useState(documentInitialState);
  const [inputTimeout, setInputTimeout] = useState<NodeJS.Timeout | null>(null);
  const [isOpenRemoveModal, setIsOpenRemoveModal] = useState<boolean>(false);
  const [copyRecord, setCopyRecord] = useState<myProjects[] | any>({});
  const [filteredCases, setFilteredCases] = useState(
    [] as { value?: string; name?: string }[]
  );
  const [selectedOption, setSelectedOption] = useState<
    OptionsProps[] | undefined
  >(undefined);
  const [copyProject, setCopyProject] = useState<{
    [key: string]: boolean | number | string | undefined | null | any;
  }>({
    isOpenCopyModal: false,
    projectName: "",
    error: "",
  });
  const { loadMyArchivedProjects, loadOtherArchivedProjects } =
    useDocumentFacade();
  const {
    loadCustomerByDetails,
    updateContact,
    updateCustomer,
    updateCustomerID,
    updateCustomerList,
    updateCustomerSearch,
    handleClearCustomer,
    loadCustomer,
  } = useCreateProjectFacade();
  const { copyMyProjectExists, copyMyProjects, removeMyProjects } =
    useProjectFacade();
  const { contact, customer, customerList, customerID, customerSearchKey } =
    useAppSelector((state) => state?.createProject);

  useEffect(() => {
    if (activeTab === 0) {
      loadMyArchivedProjects(currentParams);
    } else {
      loadOtherArchivedProjects(currentParams);
    }
  }, [currentParams]);

  useEffect(() => {
    loadCustomer({
      pageNumber: 1,
      pageSize: 100,
      SearchTerm_Contains: customerSearchKey ? customerSearchKey : "",
      SortBy: "customername", 
      SortDirection: 0
    });
  }, [customerSearchKey]);

  const handleTabChange = (tab: number): void => {
    setActiveTab(tab);
    setCurrentParams({
      SortDto: { Field: "UpdatedOn", Order: "DESC" },
      Filters: [],
      GlobalFilter: "",
      PageNumber: 1,
      PageSize: 10,
    });
  };

  const handleDropdown = (selectedOption: string, record: any) => {
    if (
      selectedOption.toLowerCase().trim() === "duplicate".toLowerCase().trim()
    ) {
      setCopyProject((prev: any) => ({
        ...prev,
        isOpenCopyModal: true,
        error: "",
      }));
      setCopyRecord(record);
      setFilteredCases(
        (record?.caseNameList || []).reduce((acc: any[], curr: any) => {
          if (
            !acc.some(
              (item) =>
                item.name === curr.caseName && item.value === curr.projectID
            )
          ) {
            acc.push({ value: curr.projectID, name: curr.caseName });
          }
          return acc;
        }, [])
      );
      setSelectedOption(
        record?.caseNameList && record?.caseNameList.length > 0
          ? [
              {
                value: record.caseNameList[0].projectID,
                name: record.caseNameList[0].caseName,
              },
            ]
          : []
      );
      // Set customer details in create project drawer
      const customerData = [...customerList];
      const findCustomer = customerList?.find(
        (item: any) => item.value === record?.customerCnxId
      );
      if ([0, null]?.includes(record?.customerCnxId) || !findCustomer) {
        customerData.unshift({
          value: record?.customerCnxId ?? null,
          label: record?.companyName,
        });
        if (![0, null]?.includes(record?.customerCnxId))
          updateCustomerList(customerData);
        updateCustomer(customerData[0]?.label);
        updateCustomerID(customerData[0]?.value);
      } else {
        updateCustomer(findCustomer?.label ?? "");
        updateCustomerID(findCustomer?.value ?? "");
      }
      if (![0, null]?.includes(record?.customerCnxId)) {
        updateCustomerList(customerData);
      } else {
        updateCustomerList(customerList);
      }

      updateContact(record?.customerContact);
    } else if (
      selectedOption.toLowerCase().trim() === "remove".toLowerCase().trim()
    ) {
      setIsOpenRemoveModal(true);
      setCopyRecord(record);
    }
  };
  const handleOnChangeCases = (option: any) => {
    setSelectedOption(option);
  };

const handleInputChange = async (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const { name, value } = event?.target;
        if (name === "projectName") {
            setCopyProject((prev: any) => ({
                ...prev,
                projectName: value,
            }));
            if (inputTimeout) {
                clearTimeout(inputTimeout);
            }
            const timeoutId = setTimeout(async () => {
                const existsPayload = {
                    ProjID: copyRecord?.projectID,
                    ProjName: event.target.value,
                };
                try {
                    const response = await copyMyProjectExists(existsPayload);
                    if (response?.payload === true) {
                        setCopyProject((prev: any) => ({
                            ...prev,
                            error: "Project name already exists.",
                        }));
                    } else {
                        setCopyProject((prev: any) => ({
                            ...prev,
                            error: "",
                        }));
                    }
                } catch (err) {
                    console.log(err, "error");
                }
            }, 1000);
            setInputTimeout(timeoutId);
        } else if (name === "contact") {
            updateContact(value);
        }
    };

  const onChangeSearchCustomer = async (e: any) => {
    const { value } = e.target;
    const keywordCount = value.trim();
    if (keywordCount.length >= 3) {
      updateCustomerSearch(value);
    } else if (keywordCount.length === 0) {
      updateCustomerSearch("");
    }
  };

    const handleOnChangeSelect = async (option: any, name: string = "") => {
        if (name === "customer") {
            if (option?.target?.value) {
                updateCustomer(option?.target?.value);
            } else {
                if (option?.value) await loadCustomerByDetails(option?.value);
                updateCustomer(option?.label);
                updateCustomerID(option?.value);
                updateContact("");
                updateCustomerSearch("");
            }
        }
    };

  const handleCopied = async () => {
    if (copyProject?.projectName) {
      const copyPayload = {
        ProjectId: copyRecord?.projectID,
        projectName: copyProject?.projectName,
        IsCaseLevel: false,
        customerCnxId: customerID,
        OperatorContact: contact,
        companyName: customer,
        DisplayCaseName: "Case #1",
        caseProjectId:
          selectedOption && selectedOption.length > 0
            ? selectedOption.map((item) => item.value).join(",")
            : "",
      };
      const response = await copyMyProjects(copyPayload);
      if (response) {
        toast.success("Project copied successfully.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          icon: <Success />,
          style: {
            background: "#f04438",
            color: "#fff",
            fontWeight: "bold",
            fontFamily: "Mulish",
            fontSize: "16px",
          },
        });
      }
      setCopyProject((prev: any) => ({
        ...prev,
        isOpenCopyModal: false,
        error: "",
        projectName: "",
      }));
      loadMyArchivedProjects(currentParams);
    }
  };

  const handleRemove = async () => {
    if (copyRecord?.projectID) {
      const payload = {
        Id: copyRecord?.projectID,
      };
      const response = await removeMyProjects(payload);
      if (response) {
        toast.success("Project deleted successfully.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          icon: <Success />,
          style: {
            background: "#f04438",
            color: "#fff",
            fontWeight: "bold",
            fontFamily: "Mulish",
            fontSize: "16px",
          },
        });
      }
      setIsOpenRemoveModal(false);
      loadMyArchivedProjects(currentParams);
    }
  };

  const tabs = [
    {
      label: "My projects",
      content: (
        <>
          <MyArchivedProjects
            currentParams={currentParams}
            setCurrentParams={setCurrentParams}
            handleDropdown={handleDropdown}
          />
        </>
      ),
    },
    {
      label: "Other projects",
      content: (
        <>
          <OtherArchivedProjects
            currentParams={currentParams}
            setCurrentParams={setCurrentParams}
            handleDropdown={handleDropdown}
          />
        </>
      ),
    },
  ];

  return (
    <div
      className='w-full flex-1 border-[1px] border-darkcolor-400 rounded-[8px]'
      style={{
        background:
          "var(--Gradient-Cards, linear-gradient(181deg, #253240 -16.87%, rgba(37, 48, 64, 0.40) 35.14%))",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      }}
    >
      <ToastContainer />
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onChange={handleTabChange}
        className=''
      />
      {(copyProject?.isOpenCopyModal || isOpenRemoveModal) && (
        <Modal
          width='50%'
          visible={copyProject?.isOpenCopyModal || isOpenRemoveModal}
          onClose={
            isOpenRemoveModal
              ? () => setIsOpenRemoveModal(!isOpenRemoveModal)
              : () => {
                  setCopyProject((prev: any) => ({
                    ...prev,
                    isOpenCopyModal: false,
                    projectName: "",
                  }));
                  handleClearCustomer();
                }
          }
          showButtons={true}
          yesButton='Confirm'
          noButton='Cancel'
          title={isOpenRemoveModal ? "Remove project" : "Copy project"}
          disabled={
            isOpenRemoveModal
              ? copyRecord?.projectID
                ? false
                : true
              : copyProject?.projectName === "" || copyProject?.error !== ""
              ? true
              : false
          }
          onConfirm={isOpenRemoveModal ? handleRemove : handleCopied}
          children={
            isOpenRemoveModal ? (
              <div className='flex justify-center items-center text-neutral-25 p-2'>
                <div className='text-left w-full text-neutral-25 p-2'>
                  Are you sure you wish to remove this project from your list?
                </div>
              </div>
            ) : (
              <>
                <div className='grid grid-cols-2 gap-2 w-full'>
                  <div className='mb-5'>
                    <TextInput
                      label='Project name'
                      value={copyProject?.projectName}
                      placeholder='Enter here'
                      onChange={(e) => handleInputChange(e)}
                      error={copyProject?.error}
                      name="projectName"
                    />
                  </div>
                  <div className='mb-5'>
                    <label className='text-neutral-25 font-medium mr-2 mb-1'>
                      Select cases you would like to copy
                    </label>
                    <ChipsDropdown
                      options={filteredCases}
                      onSelect={(options) => handleOnChangeCases(options)}
                      selectedOptions={selectedOption}
                      disabled={false}
                      disableFirstChipRemove={true}
                    />
                  </div>
                </div>
                <div className='grid grid-cols-2 gap-2 w-full'>
                  <div className=''>
                    <SelectCreate
                      options={customerList || []}
                      onChange={(option, name) =>
                        handleOnChangeSelect(option, name)
                      }
                      padding='px-[14px] sm:py-[10px] py-[5px]'
                      fontSize='16px'
                      className='sm:px-0 px-[10px]'
                      selectedValue={customer}
                      textInput={false}
                      placeholder='Select an operator'
                      label='Operator'
                      name='customer'
                      targetName='customer'
                      showCloseIcon={
                        [0, null, ""]?.includes(customerID) ? false : true
                      }
                      isSearch={true}
                      onChangeSearch={onChangeSearchCustomer}
                      onCloseDropdown={() => updateCustomerSearch("")}
                      onClear={handleClearCustomer}
                      disabled={true}
                    />
                  </div>
                  <div className=''>
                    <TextInput
                      label='Operator contact'
                      placeholder=''
                      value={contact}
                      onChange={(event) => handleInputChange(event)}
                      name='contact'
                      className='flex px-[12px] py-[10px] rounded-[8px] border-[1px] border-darkcolor-400 w-full bg-transparent text-neutral-25 focus:outline-none text-[16px] hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500'
                    />
                  </div>
                </div>
              </>
            )
          }
        />
      )}
    </div>
  );
};

export default ArchivedProjects;
